var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.track)?_c('SmallView',{attrs:{"type":"track","cover":_vm.cover,"title":_vm.track.name || _vm.$l10n("NO_NAME"),"link":("/tracks/" + (_vm.track.id)),"duration":_vm.track.duration,"artists":_vm.track.artists}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }